import { render, staticRenderFns } from "./inotes.vue?vue&type=template&id=033ef88e&"
import script from "./inotes.vue?vue&type=script&lang=js&"
export * from "./inotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports